import { render, staticRenderFns } from "./CPFInput.vue?vue&type=template&id=b6cd30e6&scoped=true&"
import script from "./CPFInput.vue?vue&type=script&lang=js&"
export * from "./CPFInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cd30e6",
  null
  
)

export default component.exports